"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
const preact_1 = require("preact");
const Time_1 = require("../../Time");
const style_1 = require("./style");
class Time extends preact_1.Component {
    constructor() {
        super(...arguments);
        this.onUpdate = () => this.forceUpdate();
    }
    componentDidMount() {
        this.offPlay = this.props.game.events.on('postupdate', this.onUpdate);
    }
    componentWillUnmount() {
        this.offPlay && this.offPlay();
    }
    render() {
        const current = (0, Time_1.formatTime)(this.props.game.getTimelineTime());
        const total = (0, Time_1.formatTime)(this.props.game.getTimelineDuration());
        return ((0, preact_1.h)("div", { class: style_1.Time.time },
            current,
            " / ",
            total));
    }
}
exports.Time = Time;
